module.exports = __webpack_public_path__ + "img/icon_upload_disabled.1058d0af.png";